const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/calendar/index.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/calendar/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { scheduleSearch } from '@/app/lib/schedule-search';
import { calendarRangeFor, DEFAULT_SCHEDULE_CALENDAR_VIEW } from '@/features/schedule/lib/calendar-view';
import { weekRange } from '@/features/schedule/lib/date';
import { getActiveScheduleWorkoutQuery } from '@/features/schedule/lib/get-active-schedule-workout.query';
import { getScheduleCalendarQuery } from '@/features/schedule/lib/get-schedule-calendar.query';
import { CalendarSkeleton } from '@/features/schedule/ui/calendar-skeleton';
export const Route = createFileRoute('/_authenticated/tracking/calendar/')({
  validateSearch: scheduleSearch,
  loaderDeps: ({
    search
  }) => ({
    view: search.view,
    anchor: search.anchor
  }),
  loader: async ({
    context,
    deps: search,
    location
  }) => {
    const queryDeps = {
      controllers: {
        scheduleController: context.deps.controllers.scheduleController
      }
    };
    const view = search.view ?? DEFAULT_SCHEDULE_CALENDAR_VIEW;
    try {
      const requestedRange = search.anchor === undefined ? null : calendarRangeFor(view, search.anchor);
      const calendar = await context.queryClient.ensureQueryData(getScheduleCalendarQuery(queryDeps, requestedRange));
      // The in-progress banner is secondary: warm, never block.
      void context.queryClient.prefetchQuery(getActiveScheduleWorkoutQuery(queryDeps));
      if (search.anchor === undefined) {
        // The server default is the week containing today. Seed that key only for week view;
        // a month deep link without an anchor still keeps month and refetches its grid.
        if (view === 'week') {
          const week = weekRange(calendar.today);
          context.queryClient.setQueryData(getScheduleCalendarQuery(queryDeps, week).queryKey, calendar);
        }
        throw redirect({
          to: '/tracking/calendar',
          search: {
            view,
            anchor: calendar.today
          },
          replace: true
        });
      }
      return {
        view,
        anchor: search.anchor,
        range: calendarRangeFor(view, search.anchor)
      };
    } catch (error) {
      return await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  pendingComponent: CalendarSkeleton
});